import React, { FC } from 'react';
import { Tip } from '@dev/ee-components';
import { Trans } from 'react-i18next';
import { Link } from '@material-ui/core';

import { FromEmailTipType } from '../../../SubjectAndContentInterface';

export const FromEmailTip: FC<FromEmailTipType> = (props: FromEmailTipType): JSX.Element => {
    const { isTipVisible, openExitModal } = props;
    if (!isTipVisible) {
        return null;
    }
    return (
        <Tip id="from-email-tip">
            <Trans i18nKey="usingfreeproviders" components={{ verifiedDomains: <Link onClick={openExitModal} /> }} />
        </Tip>
    );
};
